module.exports = __webpack_public_path__ + "img/performing_jp.f9a3746.jpg";